import SuccessScreen from './SuccessScreen.component';

export default SuccessScreen;
